(() => {
  if (window.__mcpBackInit) return;
  window.__mcpBackInit = true;

  const isSameOrigin = (url) => {
    try {
      return new URL(url, window.location.href).origin === window.location.origin;
    } catch {
      return false;
    }
  };

  const isSamePage = (url) => {
    try {
      const ref = new URL(url, window.location.href);
      return (
        ref.pathname === window.location.pathname &&
        ref.search === window.location.search
      );
    } catch {
      return false;
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-mcp-back]');
    if (!link) return;

    const referrer = document.referrer;
    if (!referrer || !isSameOrigin(referrer) || isSamePage(referrer)) return;
    if (window.history.length <= 1) return;

    event.preventDefault();
    window.history.back();
  });
})();
